<template>
  <table cellspacing="0" cellpadding="0" border="0" :style="styles">
    <colgroup>
      <col v-for="(column, index) in columns" :width="setCellWidth(column)" />
      <col v-if="$parent.showVerticalScrollBar" :width="$parent.scrollBarWidth" />
    </colgroup>
    <thead>
      <tr v-for="(cols, rowIndex) in headRows">
        <th
          v-for="(column, index) in cols"
          :colspan="column.colSpan"
          :rowspan="column.rowSpan"
          :class="alignCls(column)"
          :style="hasChildStyle(column)"
        >
          <div :class="cellClasses(column)">
            <template v-if="column.type === 'expand'">
              <span v-if="!column.renderHeader">{{ column.title || '' }}</span>
              <render-header
                v-else
                :render="column.renderHeader"
                :column="column"
                :index="index"
              ></render-header>
            </template>
            <template v-else-if="column.type === 'selection'">
              <Checkbox
                :value="isSelectAll"
                :disabled="!data.length"
                @on-change="selectAll"
              ></Checkbox>
            </template>
            <template v-else>
              <span
                v-if="!column.renderHeader"
                :class="{ [prefixCls + '-cell-sort']: column.sortable }"
                @click="handleSortByHead(getColumn(rowIndex, index)._index, rowIndex, index)"
              >
                {{ column.title }}
              </span>
              <render-header
                v-else
                :render="column.renderHeader"
                :column="column"
                :index="index"
              ></render-header>
              <span :class="[prefixCls + '-sort']" v-if="column.sortable">
                <i
                  class="ivu-icon ivu-icon-md-arrow-dropup"
                  :class="{ on: getColumn(rowIndex, index)._sortType === 'asc' }"
                  @click="handleSort(getColumn(rowIndex, index)._index, 'asc', rowIndex, index)"
                ></i>
                <i
                  class="ivu-icon ivu-icon-md-arrow-dropdown"
                  :class="{ on: getColumn(rowIndex, index)._sortType === 'desc' }"
                  @click="handleSort(getColumn(rowIndex, index)._index, 'desc', rowIndex, index)"
                ></i>
              </span>
              <span v-if="column.sortable && mulitSort" class="change_sort">
                {{ getColumnName(rowIndex, index) }}
              </span>
              <Poptip
                v-if="isPopperShow(column)"
                v-model="getColumn(rowIndex, index)._filterVisible"
                placement="bottom"
                popper-class="ivu-table-popper"
                transfer
                @on-popper-hide="handleFilterHide(getColumn(rowIndex, index)._index)"
              >
                <span :class="[prefixCls + '-filter']">
                  <i
                    class="ivu-icon ivu-icon-ios-funnel"
                    :class="{ on: getColumn(rowIndex, index)._filterChecked.length }"
                  ></i>
                </span>
                <div
                  slot="content"
                  :class="[prefixCls + '-filter-list']"
                  v-if="getColumn(rowIndex, index)._filterMultiple"
                >
                  <LutticaScrollBar v-if="column.filters.length * 18 > 250" height="250px">
                    <div :class="[prefixCls + '-filter-list-item']">
                      <checkbox-group v-model="getColumn(rowIndex, index)._filterChecked">
                        <checkbox
                          v-for="(item, index) in column.filters"
                          :key="index"
                          :label="item.value"
                        >
                          {{ item.label }}
                        </checkbox>
                      </checkbox-group>
                    </div>
                  </LutticaScrollBar>
                  <div :class="[prefixCls + '-filter-list-item']" v-else>
                    <checkbox-group v-model="getColumn(rowIndex, index)._filterChecked">
                      <checkbox
                        v-for="(item, index) in column.filters"
                        :key="index"
                        :label="item.value"
                      >
                        {{ item.label }}
                      </checkbox>
                    </checkbox-group>
                  </div>
                  <div :class="[prefixCls + '-filter-footer']">
                    <i-button
                      type="text"
                      size="small"
                      @click.native="handleReset(getColumn(rowIndex, index)._index)"
                    >
                      <!--<LutticaIcon type="iconfanhui"></LutticaIcon>-->
                      <CloudButton
                        class="tabel-head-cancelButton"
                        shape="circle"
                        style="line-height: 1"
                        short
                      >
                        {{ $t('info16') }}
                      </CloudButton>
                    </i-button>
                    <i-button
                      type="text"
                      size="small"
                      :disabled="!getColumn(rowIndex, index)._filterChecked.length"
                      @click.native="handleFilter(getColumn(rowIndex, index)._index)"
                    >
                      <!--<LutticaIcon type="iconfanhui"></LutticaIcon>-->
                      <CloudButton
                        type="primary"
                        shape="circle"
                        style="margin-left: -8px; line-height: 1"
                        short
                      >
                        {{ $t('button03') }}
                      </CloudButton>
                    </i-button>
                  </div>
                </div>
                <div slot="content" :class="[prefixCls + '-filter-list']" v-else>
                  <ul :class="[prefixCls + '-filter-list-single']">
                    <li
                      :class="itemAllClasses(getColumn(rowIndex, index))"
                      @click="handleReset(getColumn(rowIndex, index)._index)"
                    >
                      {{ t('i.table.clearFilter') }}
                    </li>
                    <li
                      :class="itemClasses(getColumn(rowIndex, index), item)"
                      v-for="item in column.filters"
                      @click="handleSelect(getColumn(rowIndex, index)._index, item.value)"
                    >
                      {{ item.label }}
                    </li>
                  </ul>
                </div>
              </Poptip>
            </template>
            <span class="index" v-if="getSelectIndexList.includes(column.key) && mulitSort">
              {{ getSelectIndexList.indexOf(column.key) + 1 }}
            </span>
          </div>
        </th>

        <th
          v-if="$parent.showVerticalScrollBar && rowIndex === 0"
          :class="scrollBarCellClass()"
          :rowspan="headRows.length"
        ></th>
      </tr>
    </thead>
  </table>
</template>
<script>
import { mapState } from 'vuex';
import CheckboxGroup from '../checkbox/checkbox-group.vue';
import Checkbox from '../checkbox/checkbox.vue';
import Poptip from '../poptip/poptip.vue';
import iButton from '../button/button.vue';
import renderHeader from './header';
import Mixin from './mixin';
import Locale from '../../mixins/locale';

export default {
  name: 'TableHead',
  mixins: [Mixin, Locale],
  components: { CheckboxGroup, Checkbox, Poptip, iButton, renderHeader },
  props: {
    sortList: {
      type: Array,
      default: () => [],
    },
    prefixCls: String,
    styleObject: Object,
    columns: Array,
    objData: Object,
    data: Array, // rebuildData
    columnsWidth: Object,
    fixed: {
      type: [Boolean, String],
      default: false,
    },
    mulitSort: {
      type: [Boolean, String],
      default: false,
    },
    columnRows: Array,
    fixedColumnRows: Array,
  },
  computed: {
    ...mapState(['contentWidth', 'contentHeight']),
    tableHeight() {
      return this.contentHeight - 200 - 102 - 50;
    },
    styles() {
      const style = Object.assign({}, this.styleObject);
      const width = parseInt(this.styleObject.width);
      style.width = `${width}px`;
      return style;
    },
    isSelectAll() {
      let isSelectAll = true;
      if (!this.data.length) isSelectAll = false;
      if (!this.data.find(item => !item._disabled)) isSelectAll = false; // #1751
      for (let i = 0; i < this.data.length; i++) {
        if (
          !this.objData[this.data[i]._index]._isChecked &&
          !this.objData[this.data[i]._index]._isDisabled
        ) {
          isSelectAll = false;
          break;
        }
      }

      return isSelectAll;
    },
    headRows() {
      const isGroup = this.columnRows.length > 1;
      if (isGroup) {
        // console.log(this.fixed ? this.fixedColumnRows : this.columnRows)
        return this.fixed ? this.fixedColumnRows : this.columnRows;
      } else {
        return [this.columns];
      }
    },
    getSelectIndexList() {
      if (this.headRows && this.headRows.length && this.sortList) {
        const skeyList = this.sortList.map(item => item.key);
        const indexList = [];
        skeyList.forEach(key => {
          this.columns.forEach(item => {
            if (key === item.key) indexList.push(item.key);
          });
        });
        return indexList;
      }
      return [];
    },
  },
  data() {
    return {
      childStyle: ['#899ea1', '#a3b8bb', '#c3d2d4', '#dfe9ea'],
    }
  },
  methods: {
    cellClasses(column) {
      return [
        `${this.prefixCls}-cell`,
        {
          [`${this.prefixCls}-hidden`]:
            !this.fixed && column.fixed && (column.fixed === 'left' || column.fixed === 'right'),
          [`${this.prefixCls}-cell-with-selection`]: column.type === 'selection',
        },
      ];
    },
    scrollBarCellClass() {
      let hasRightFixed = false;
      for (let i in this.headRows) {
        for (let j in this.headRows[i]) {
          if (this.headRows[i][j].fixed === 'right') {
            hasRightFixed = true;
            break;
          }
          if (hasRightFixed) break;
        }
      }
      return [
        {
          [`${this.prefixCls}-hidden`]: hasRightFixed,
        },
      ];
    },
    itemClasses(column, item) {
      return [
        `${this.prefixCls}-filter-select-item`,
        {
          [`${this.prefixCls}-filter-select-item-selected`]:
            column._filterChecked[0] === item.value,
        },
      ];
    },
    itemAllClasses(column) {
      return [
        `${this.prefixCls}-filter-select-item`,
        {
          [`${this.prefixCls}-filter-select-item-selected`]: !column._filterChecked.length,
        },
      ];
    },
    selectAll() {
      const status = !this.isSelectAll;
      this.$parent.selectAll(status);
    },
    handleSort(index, type, rowIndex, indexT) {
      // 在固定列时，寻找正确的 index #5580
      const column = this.columns.find(item => item._index === index);
      const _index = column._index;
      const { _sortType, key } = column;
      if (_sortType === type) {
        type = 'normal';
      }
      const newSortList = JSON.parse(JSON.stringify(this.sortList));
      if (newSortList) {
        const dk = {
          key,
          order: type,
        };
        const hidx = newSortList.findIndex(item => item.key === key);
        if (hidx === -1) {
          newSortList.push(dk);
        } else {
          if (type === 'normal') newSortList.splice(hidx, 1);
          else newSortList.splice(hidx, 1, dk);
        }
      }
      this.$parent.handleSort(_index, type, newSortList);
    },
    handleSortByHead(index, rowIndex, indexT) {
      // 在固定列时，寻找正确的 index #5580
      const column = this.columns.find(item => item._index === index);
      if (column.sortable) {
        const type = column._sortType;
        if (type === 'normal') {
          this.handleSort(index, 'asc', rowIndex, indexT);
        } else if (type === 'asc') {
          this.handleSort(index, 'desc', rowIndex, indexT);
        } else {
          this.handleSort(index, 'normal', rowIndex, indexT);
        }
      }
    },
    handleFilter(index) {
      this.$parent.handleFilter(index);
    },
    handleSelect(index, value) {
      this.$parent.handleFilterSelect(index, value);
    },
    handleReset(index) {
      this.$parent.handleFilterReset(index);
    },
    handleFilterHide(index) {
      this.$parent.handleFilterHide(index);
    },
    // 因为表头嵌套不是深拷贝，所以没有 _ 开头的方法，在 isGroup 下用此列
    getColumn(rowIndex, index) {
      const isGroup = this.columnRows.length > 1;
      if (isGroup) {
        const id = this.headRows[rowIndex][index].__id;
        return this.columns.filter(item => item.__id === id)[0];
      } else {
        return this.headRows[rowIndex][index];
      }
    },
    getColumnName(rowIndex, index) {
      let res;
      const isGroup = this.columnRows.length > 1;
      if (isGroup) {
        const id = this.headRows[rowIndex][index].__id;
        res = this.columns.filter(item => item.__id === id)[0];
      } else {
        res = this.headRows[rowIndex][index];
      }
    },
    hasChildStyle(row) {
      if (row.children) {
        const index = row.level + (this.childStyle.length - this.headRows.length);
        return { backgroundColor: this.childStyle[index > 4 ? 4 : index] }
      }
      return { }
    }
  },
};
</script>

<style lang="less">
.change_sort {
  color: #999;
  font-size: 10px;
  font-weight: bold;
}
.tabel-head-cancelButton {
  border-color: @primary-color;
  &:hover {
    background-color: #e2f0ff !important;
  }
}
.ivu-table-filter-list-item {
  .ivu-checkbox-wrapper {
    padding: 2.5px 0;
    .ivu-checkbox-inner {
      margin-right: 5px;
    }
  }
}
</style>
